import { React, Fragment } from 'react'
import { CheckIcon, MinusIcon, PlusIcon } from '@heroicons/react/solid'
import Section from '../Section'
import {BasicLogo, PremiumLogo, AdvancedLogo} from '../../../images/index.js'
import Button from '../../../components/landingPage/Button'

const tiers = [
  { name: 'Basic', href: '#', priceMonthly: 9, description: 'Quis suspendisse ut fermentum neque vivamus non tellus.', image: BasicLogo},
  {
    name: 'Advanced',
    href: '#',
    priceMonthly: 29,
    description: 'Quis eleifend a tincidunt pellentesque. A tempor in sed.',
    image: AdvancedLogo
  },
  {
    name: 'Premium',
    href: '#',
    priceMonthly: 59,
    description: 'Orci volutpat ut sed sed neque, dui eget. Quis tristique non.',
    image: PremiumLogo
  },
]
const sections = [
  {
    name: 'Optimized Procedures',
    features: [
      { name: 'Controlled Full Digital Workflow & Cosmetic Dentistry', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Minimally invasive dentistry', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Full Cloud connectivity to "My XiViX Platform"', tiers: {Basic:4, Advanced: 4, Premium: 4 } },
      { name: 'Global Oral health & Gradient Therapeutic approach', tiers: {Basic:4, Advanced: 4, Premium: 4 } },
      { name: 'New XiViX Innovative Process - Shorter journey', tiers: {Basic:4, Advanced: 4, Premium: 4 } },
      { name: 'Chairside Single visit dentistry availablee @ e-LAB', tiers: {Basic:4, Advanced: 4, Premium: 4 } },
      
    ],
  },
  {
    name: 'CIPP',
    features: [
      { name: 'Central AI, Analyse, Diagnose and Treatment Plans', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'CENTRAL PRODUCTION : HIGH-TECH Factory CAD-CAM & 3D Print', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'LABwork 100% Made in EU by Qualified Dental Technicians', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Economy of Scale on all treatments', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Best QUALITY / PRICE ratio', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
    ],
  },
  {
    name: 'Materials',
    features: [
      { name: 'Choice of Innovat6ive uptodate Biomaterials', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Certified EU, Highest Quality Materials', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Traceability Medical Device Regulation EU 2017/745', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Predictable & Sustainable results', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'XiViX ORIGINAL & HIGH QUALITY CERTIFICATIONS', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
    ],
  },
  {
    name: 'Patient',
    features: [
      { name: 'Level of requirements', tiers: { Basic: "Basic Aesthetics", Advanced: "Advanced Aesthetics", Premium: "High End Aesthetics" } },
      { name: 'Pricing', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
      { name: 'Number of visits or Journey', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
    ],
  },
  {
    name: 'GP',
    features: [
      { name: 'Level of requirements', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
      { name: 'Chair time', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
    ],
  },
  {
    name: 'LAB',
    features: [
      { name: 'Knowledge, Experience & skills', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
      { name: 'LAB time', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
    ],
  },
  {
    name: 'Fixed Prosthetics',
    features: [
      { name: 'Crowns & Bridges Temporization', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
      { name: '3D PRINTED MODELS included in price', tiers: { Advanced: 4, Premium: 4 } },
      { name: 'Cosmetic Selection : Multilayers 1 LV shade per tooth', tiers: { Advanced: 4, Premium: 4 } },
      { name: 'Cosmetic Select : Gradient of 2 LV shadeguide & Enamel T/ tooth', tiers: { Advanced: 4, Premium: 4 } },
      { name: 'More experienced Ceramist /DT', tiers: { Advanced: 4, Premium: 4 } },
      { name: 'More colorful staining involved', tiers: { Advanced: 4, Premium: 4 } },
      { name: 'Master Ceramist - higher skills- performances involved', tiers: { Premium: 4 } },
      { name: 'Photos/ Personnalized Shade Selection at XiViX e-LAB', tiers: { Premium: 4 } },
      { name: 'Highly Personnalized & Multilayering techniques', tiers: { Premium: 4 } },
    ],
  },
  {
    name: 'Design',
    features: [
      { name: 'Functional Occlusal design', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Natural & Complex caracterization (staining & texture)', tiers: { Advanced: 1, Premium: 3 } },
      { name: 'Frontal Smile design', tiers: { Advanced: 1, Premium: 3 } },
      { name: 'Virtual Wax-ups (supplement)', tiers: { Advanced: 1, Premium: 3 } },
      { name: 'Mock ups (supplement)', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
    ],
  },
  {
    name: 'Implantology',
    features: [
      { name: 'Selection of 1 or 2 Highest Grade IMPLANTS', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Certified Original Implants & Components', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: '3D Planified Surgery for Implant Placement', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Placed by Experts @ XiViX SCE Specialized Center of Excellence', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Customized Implant Abutments if necessary', tiers: { Basic: 4, Advanced: 4, Premium: 4 } },
      { name: 'Variability of Implants Temporization', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
      { name: 'Reshaping cosmetics to optimize Pink & White Aesthetics', tiers: { Basic: 1, Advanced: 2, Premium: 3 } },
    ],
  },
  {
    name: 'Removables',
    features: [
      { name: 'Base of Digital Dentures Full Upper & / Lower', tiers: { Basic: "Resin 3D Print", Advanced: "Resin MILLED", Premium: "Resin MILLED" } },
      { name: 'Base of Removable Partial Dentures', tiers: { Basic: "Resin 3D Print", Advanced: "Metal & resin", Premium: "PEEK & Resin" } },
      { name: 'Selection of Teeth Partial & Full', tiers: { Basic: "BASIC", Advanced: "ADVANCED", Premium: "PREMIUM" } },
    ],
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function TreatmentPlans() {
  return (
    <Section title="Our Treatment Plans" subtitleClassName="-mb-10" subtitle="At XiViX, with informed consent, we give you the power to choose your desired level of aesthetics without compromising on quality, function and design." id="TreatmentPlans">
      <div className="bg-white mt-28">
        <div className="max-w-7xl mx-auto bg-white sm:px-6 lg:px-8">
          {/* xs to lg */}
          <div className="max-w-2xl mx-auto space-y-16 lg:hidden">
            {tiers.map((tier, tierIdx) => (
              <section key={tier.name}>
                <div className="px-4  mb-8">
                  <img src={tier.image} className="w-32 mx-auto"/>
                  <h2 className="text-xl leading-6 font-medium text-center text-gray-900">{tier.name}</h2>
                </div>
                {sections.map((section) => (
                  <table key={section.name} className="w-full">
                    <caption className="bg-primary border-t border-gray-200 py-3 px-4 text-md font-medium text-white text-left">
                      {section.name}
                    </caption>
                    <thead>
                      <tr>
                        <th className="sr-only" scope="col">
                          Feature
                        </th>
                        <th className="sr-only" scope="col">
                          Included
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {section.features.map((feature) => (
                        <tr key={feature.name} className="border-t border-gray-200">
                          <th className="py-5 px-4 text-md font-normal text-gray-500 text-left" scope="row">
                            {feature.name}
                          </th>
                          <td className="py-5 pr-4 text-right">
                            {typeof feature.tiers[tier.name] === 'string' ? (
                              <span className="block text-md text-gray-700 text-right">{feature.tiers[tier.name]}</span>
                            ) : (
                              <>
                                {feature.tiers[tier.name] === 4 && <CheckIcon className="ml-auto h-5 w-5 text-green-500" aria-hidden="true"/>}
                                {feature.tiers[tier.name] === 1 && <PlusIcon className="ml-auto h-5 w-5 text-green-500" aria-hidden="true"/>}
                                {feature.tiers[tier.name] === 2 && (
                                  <div className="flex justify-end">
                                    <PlusIcon className="h-5 w-5 text-green-500" aria-hidden="true"/> 
                                    <PlusIcon className="h-5 w-5 text-green-500" aria-hidden="true"/>
                                  </div>
                                )}
                                {feature.tiers[tier.name] === 3 && (
                                  <div className="flex justify-end">
                                    <PlusIcon className="h-5 w-5 text-green-500" aria-hidden="true"/> 
                                    <PlusIcon className="h-5 w-5 text-green-500" aria-hidden="true"/>
                                    <PlusIcon className="h-5 w-5 text-green-500" aria-hidden="true"/>
                                  </div>
                                )}
                                {feature.tiers[tier.name] === undefined && <MinusIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />}
                                

                                <span className="sr-only">{feature.tiers[tier.name] === true ? 'Yes' : 'No'}</span>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ))}

                
              </section>
            ))}
          </div>

          {/* lg+ */}
          <div className="hidden lg:block">
            <table className="w-full h-px table-fixed">
              <caption className="sr-only">Pricing plan comparison</caption>
              <thead>
                <tr>
                  <th className="pb-4 px-6 text-md font-medium text-gray-900 text-left" scope="col">
                    <span className="sr-only">Feature by</span>
                  </th>
                  {tiers.map((tier) => (
                    <th
                      key={tier.name}
                      className="w-1/4 pb-4 px-6 text-xl leading-6 font-medium text-gray-900 text-center"
                      scope="col"
                    >
                      <>
                      <img src={tier.image} className="w-28 mx-auto"/>
                      {tier.name}
                      </>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="border-t border-gray-200 divide-y divide-gray-200">
                
                {sections.map((section) => (
                  <Fragment key={section.name}>
                    <tr>
                      <th
                        className="bg-primary py-3 pl-6 text-md font-medium text-white text-left"
                        colSpan={4}
                        scope="colgroup"
                      >
                        {section.name}
                      </th>
                    </tr>
                    {section.features.map((feature) => (
                      <tr key={feature.name}>
                        <th className="py-5 px-6 text-md font-normal text-gray-500 text-left" scope="row">
                          {feature.name}
                        </th>
                        {tiers.map((tier) => (
                          <td key={tier.name} className="py-5 px-6">
                            {typeof feature.tiers[tier.name] === 'string' ? (
                              <span className="block text-center text-md text-gray-700">{feature.tiers[tier.name]}</span>
                            ) : (
                              <>
                                {feature.tiers[tier.name] === 4 && <CheckIcon className="mx-auto h-5 w-5 text-green-500" aria-hidden="true"/>}
                                {feature.tiers[tier.name] === 1 && <PlusIcon className="mx-auto h-5 w-5 text-green-500" aria-hidden="true"/>}
                                {feature.tiers[tier.name] === 2 && (
                                  <div className="flex justify-center">
                                    <PlusIcon className="mx-1 h-5 w-5 text-green-500" aria-hidden="true"/> 
                                    <PlusIcon className="mx-1 h-5 w-5 text-green-500" aria-hidden="true"/>
                                  </div>
                                )}
                                {feature.tiers[tier.name] === 3 && (
                                  <div className="flex justify-center">
                                    <PlusIcon className="mx-1 h-5 w-5 text-green-500" aria-hidden="true"/> 
                                    <PlusIcon className="mx-1 h-5 w-5 text-green-500" aria-hidden="true"/>
                                    <PlusIcon className="mx-1 h-5 w-5 text-green-500" aria-hidden="true"/>
                                  </div>
                                )}
                                {feature.tiers[tier.name] === undefined && <MinusIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />}
                                

                                <span className="sr-only">{feature.tiers[tier.name] === true ? 'Yes' : 'No'}</span>
                              </>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </Fragment>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t border-gray-200">
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </Section>
  )
}